export default __webpack_public_path__ + "static/media/Ass_2.10ab3c38.svg";